import { render, staticRenderFns } from "./Productslist.vue?vue&type=template&id=1bfd4279&scoped=true&"
import script from "./Productslist.vue?vue&type=script&lang=js&"
export * from "./Productslist.vue?vue&type=script&lang=js&"
import style0 from "./Productslist.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Productslist.vue?vue&type=style&index=1&id=1bfd4279&scoped=true&lang=scss&"
import style2 from "./Productslist.vue?vue&type=style&index=2&id=1bfd4279&scoped=true&lang=css&"
import style3 from "./Productslist.vue?vue&type=style&index=3&id=1bfd4279&scoped=true&lang=css&"
import style4 from "./Productslist.vue?vue&type=style&index=4&id=1bfd4279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfd4279",
  null
  
)

export default component.exports